type SortOrder = 'ASC' | 'DESC'

export function multiSortArray<T extends Record<string, any>>(arr: T[], columns: (keyof T)[] = [], order_by: SortOrder[] = []): T[] {
  try {
    if (columns.length === 0 && arr.length > 0) {
      columns = Object.keys(arr[0]) as (keyof T)[]
    }

    if (order_by.length === 0) {
      order_by = columns.map(() => 'ASC')
    }

    function multisortRecursive(a: T, b: T, cols: (keyof T)[], orderBy: SortOrder[], index: number): number {
      const key = cols[index]
      const dir = orderBy[index] === 'DESC' ? -1 : 1

      let valA = a[key]
      let valB = b[key]

      if (typeof valA === 'string') {
        valA = valA.toLowerCase()
      } else if (typeof valA !== 'number') {
        valA = valA.toString().toLowerCase()
      }

      if (typeof valB === 'string') {
        valB = valB.toLowerCase()
      } else if (typeof valB !== 'number') {
        valB = valB.toString().toLowerCase()
      }

      if (valA < valB) {
        return -1 * dir
      }
      if (valA > valB) {
        return 1 * dir
      }

      return cols.length - 1 > index ? multisortRecursive(a, b, cols, orderBy, index + 1) : 0
    }

    return arr.sort((a, b) => multisortRecursive(a, b, columns, order_by, 0))
  } catch (error) {
    console.error('Error in multiSortArray:', error)
    return arr
  }
}
